import { setNonce } from "get-nonce"

const nonces = new WeakMap<Document, string | undefined>()

export function documentStyleNonce(doc: Document) {
  if (!nonces.has(doc)) {
    // An Inertia response cannot replace the policy of the original document.
    nonces.set(doc, doc.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content || undefined)
  }
  return nonces.get(doc)
}

export function initializeVendorStyleNonce() {
  if (typeof document === "undefined") return
  const nonce = documentStyleNonce(document)
  if (nonce) setNonce(nonce)
}

initializeVendorStyleNonce()
